/**
 * IA Sticky Add-to-Cart Bar
 * Shows a fixed bottom bar when the main ATC button scrolls out of view.
 * Uses IntersectionObserver. Works on mobile.
 */
(function () {
  'use strict';

  if (document.querySelector('.ia-sticky-atc')) return;

  // Only run on product pages
  var mainATC = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]');
  if (!mainATC) return;

  // Gather product info from the page
  var titleEl = document.querySelector('.product__title, h1.h1, h1');
  var priceEl = document.querySelector('.price-item--regular, .price__regular .price-item, .price-item--sale, .price-item');
  var productTitle = titleEl ? titleEl.textContent.trim() : '';
  var productPrice = priceEl ? priceEl.textContent.trim() : '';

  // Build the sticky bar
  var bar = document.createElement('div');
  bar.className = 'ia-sticky-atc';
  bar.innerHTML =
    '<div class="ia-sticky-atc__inner">' +
      '<div class="ia-sticky-atc__info">' +
        '<span class="ia-sticky-atc__title">' + productTitle + '</span>' +
        '<span class="ia-sticky-atc__price">' + productPrice + '</span>' +
      '</div>' +
      '<button class="ia-sticky-atc__btn" type="button">Add to Cart</button>' +
    '</div>';

  // Inject styles
  var style = document.createElement('style');
  style.textContent =
    '.ia-sticky-atc{position:fixed;bottom:0;left:0;right:0;z-index:9998;background:#fff;' +
    'box-shadow:0 -2px 12px rgba(0,0,0,.12);transform:translateY(100%);transition:transform .3s ease;font-family:Roboto,sans-serif;}' +
    '.ia-sticky-atc--visible{transform:translateY(0);}' +
    '.ia-sticky-atc__inner{max-width:1200px;margin:0 auto;padding:10px 20px;display:flex;align-items:center;justify-content:space-between;gap:12px;}' +
    '.ia-sticky-atc__info{display:flex;flex-direction:column;min-width:0;}' +
    '.ia-sticky-atc__title{font-weight:600;font-size:14px;color:#1a1a1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:50vw;}' +
    '.ia-sticky-atc__price{font-size:14px;color:#555;font-weight:500;}' +
    '.ia-sticky-atc__btn{background:#334FB4;color:#fff;border:none;padding:12px 28px;font-size:14px;font-weight:600;' +
    'border-radius:4px;cursor:pointer;white-space:nowrap;font-family:Roboto,sans-serif;letter-spacing:.5px;text-transform:uppercase;transition:background .2s;}' +
    '.ia-sticky-atc__btn:hover{background:#2a3f90;}' +
    '@media(max-width:749px){.ia-sticky-atc__inner{padding:8px 12px;}.ia-sticky-atc__title{max-width:45vw;font-size:13px;}' +
    '.ia-sticky-atc__btn{padding:10px 18px;font-size:13px;}}';
  document.head.appendChild(style);
  document.body.appendChild(bar);

  // Click handler - trigger the actual form submit
  bar.querySelector('.ia-sticky-atc__btn').addEventListener('click', function () {
    mainATC.click();
  });

  // Update price when variant changes
  var priceObserver = new MutationObserver(function () {
    var newPrice = document.querySelector('.price-item--regular, .price__regular .price-item, .price-item--sale, .price-item');
    if (newPrice) {
      bar.querySelector('.ia-sticky-atc__price').textContent = newPrice.textContent.trim();
    }
  });
  var priceContainer = document.querySelector('.price');
  if (priceContainer) {
    priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  // IntersectionObserver to show/hide
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        bar.classList.remove('ia-sticky-atc--visible');
      } else {
        bar.classList.add('ia-sticky-atc--visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(mainATC);
})();
